import { render, staticRenderFns } from "./orderLog.vue?vue&type=template&id=394a036d"
import script from "./orderLog.vue?vue&type=script&lang=js"
export * from "./orderLog.vue?vue&type=script&lang=js"
import style0 from "./orderLog.vue?vue&type=style&index=0&id=394a036d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports